/**
 * 版本号比较
 * @param {string} v1 版本号1，形如"2.2.3"，默认为cookie中v
 * @param {string} v2 版本号2
 * @return {number} 比较结果，[-1 小于 | 0 等于 | 1 大于]
 */
import { cookie, env } from '@zz-common/zz-utils'
export const compareVs = (v2, v1) => {
  const v = v1 || currentV()
  return env.compareVersion(v, v2)
}

export const currentV = () => {
  const version = cookie.get('v') || ''
  return version
}
